// Page units: 1 unit = 1 PDF point, so the saved design maps 1:1 onto the backend's PDF page.
export const POINTS_PER_INCH = 72;

// Font families the backend PDF engine can render (FontRegistry in printpros.PdfEngine).
// Text is limited to these so the printed PDF matches the editor.
// ASSUMED LIST — confirm against FontRegistry; the first entry is the default for new text.
export const BANNER_FONTS = [
  'Helvetica Neue',
  'Arial',
  'Times New Roman',
  'Georgia',
  'Courier New',
  'Impact',
];

export const BANNER_FONT_SIZES = [24, 36, 48, 72, 96, 120, 150, 200, 250, 300, 400];
